module.exports = __webpack_public_path__ + "img/Group 1664@2x.b15dcba5.png";